import React from 'react';
import { splitPolicyBlocks, isNumberedSectionHeading } from '../content/equipmentLoanPolicy';

/**
 * Renders the equipment loan policy body (same text as /booking/equipment/policy).
 */
export default function EquipmentLoanPolicyContent({ className = '' }) {
  const blocks = splitPolicyBlocks();

  return (
    <div
      className={`font-literary text-primary-800 dark:text-gray-200 space-y-4 text-sm leading-relaxed ${className}`}
    >
      {blocks.map((block, i) => {
        const t = block.trim();
        if (isNumberedSectionHeading(t)) {
          return (
            <h2
              key={i}
              className="text-base font-serif font-semibold text-primary-900 dark:text-white pt-3 first:pt-0 border-b border-primary-200 dark:border-gray-600 pb-2"
            >
              {t}
            </h2>
          );
        }
        return (
          <p key={i} className="whitespace-pre-line">
            {t}
          </p>
        );
      })}
    </div>
  );
}
